* {
  box-sizing: border-box;
}

.card-wrapper {
  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: calc(var(--spacer) / 2);
  background: var(--white-layout-303-level-2-elevation);
  padding: calc(var(--spacer) * 5);
  height: 100%;
  min-height: 270px;

  &.readonly {
    pointer-events: none;
    background: var(--chart-052-graph-background);
  }

  &:not(.readonly) {
    &:hover {
      box-shadow: 5px 5px 10px 0 rgb(0 0 0 / 10%);
    }
  }

  &:not(.readonly).hover-editable {
    cursor: pointer;
  }

  &:focus-visible,
  &:focus {
    border: 1px solid var(--blue-layout-500-focus);
  }
}

.centered {
  height: calc(var(--spacer) * 3);
  display: flex;
  align-items: center;
}

.card-title {
  color: var(--body-text-arrows-400);
}

.card-logo-container {
  height: 72px;
  width: 72px;
  min-width: 72px;
  min-height: 72px;
  background: var(--white-layout-201-secondary-on-dark-background);
  border-radius: 50%;
  position: relative;
}

.image-section {
  width: 100%;
  height: calc(var(--spacer) * 8.5);
  display: flex;
  justify-content: space-between;
  margin: var(--spacer) 0;
  gap: calc(var(--spacer) * 2);

  #card-logo {
    display: block;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

}

.description {
  height: calc(var(--spacer) * 5);
  margin-bottom: calc(var(--spacer) * 0.5);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
  -webkit-line-clamp: 2;

  gz-text {
    line-height: 1.4;
  }
}

.status-line {
  display: flex;
  gap: var(--spacer);

  & > * {
    width: fit-content;
  }
}

.details-title {
  margin: calc(var(--spacer) * 3) 0 var(--spacer) 0;
  text-transform: uppercase;
  color: var(--body-text-arrows-400);
}

.details-container {
  display: flex;
  gap: var(--spacer);
  color: var(--body-text-arrows-400);

  .details-name-container {
    min-width: 140px;
  }
  .details-value-container {
    overflow: hidden;
  }
}

.line-label {
  & > * {
    width: fit-content;
  }
}

.link-button {
  margin: 0 0 2px -2px;
  pointer-events: auto;
  &::part(button) {
    padding: 0;
  }
}

.buttons-container {
  display: flex;
  margin-top: calc(var(--spacer) * 3);
  gap: calc(var(--spacer) * 2);

  .disabled {
    pointer-events: auto;
  }
}
